"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatRoom = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
/**
 * 채팅 화면 레이아웃 컨테이너
 *
 * <mm-chat-room>
 *   <mm-chat-header>...</mm-chat-header>
 *   <mm-chat-body>...</mm-chat-body>
 *   <mm-chat-footer>...</mm-chat-footer>
 * </mm-chat-room>
 */
let ChatRoom = class ChatRoom extends lit_1.LitElement {
    render() {
        return (0, lit_1.html) `
      <slot></slot>
    `;
    }
};
ChatRoom.styles = (0, lit_1.css) `
    :host {
      position: relative;
      display: flex;
      flex-direction: column;
      height: 100%;
      overflow: hidden;
    }
  `;
ChatRoom = __decorate([
    (0, decorators_js_1.customElement)('mm-chat-room')
], ChatRoom);
exports.ChatRoom = ChatRoom;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2hhdC1yb29tLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiY2hhdC1yb29tLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUEyQztBQUMzQyxxREFBaUQ7QUFFakQ7Ozs7Ozs7O0dBUUc7QUFFSSxJQUFNLFFBQVEsR0FBZCxNQUFNLFFBQVMsU0FBUSxnQkFBVTtJQVd0QyxNQUFNO1FBQ0osT0FBTyxJQUFBLFVBQUksRUFBQTs7S0FFVixDQUFBO0lBQ0gsQ0FBQzs7QUFkTSxlQUFNLEdBQUcsSUFBQSxTQUFHLEVBQUE7Ozs7Ozs7O0dBUWxCLENBQUE7QUFUVSxRQUFRO0lBRHBCLElBQUEsNkJBQWEsRUFBQyxjQUFjLENBQUM7R0FDakIsUUFBUSxDQWdCcEI7QUFoQlksNEJBQVEifQ==